import type { LiveUpdatesStack } from 'api/liveUpdates.types'
import { buildTranslate } from 'locales'

const tStack = buildTranslate('live_updates.stack')

export type StackChip = { label: string; name: string }

// The detected stack as label/name pairs, one per provider the stack actually
// has — a null provider is omitted. Shared by the Configuration tab's chip
// line (Figma) and the Overview setup preview's one-line read-back, so the two
// tabs always describe the same configuration the same way.
export const stackChips = (stack: LiveUpdatesStack): StackChip[] => {
  const chips: StackChip[] = []
  if (stack.orderingProvider) {
    chips.push({
      label: tStack('ordering'),
      name: stack.orderingProvider.displayName,
    })
  }
  if (stack.deliveryProvider) {
    chips.push({
      label: tStack('delivery'),
      name: stack.deliveryProvider.displayName,
    })
  }
  if (stack.statusProvider) {
    chips.push({
      label: tStack('status_provider'),
      name: stack.statusProvider.displayName,
    })
  }
  return chips
}
